import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-506298b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "mb-2 text-xl" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-text mb-1" }, "Select the game which you would like to link to your Asset.", -1))
const _hoisted_4 = {
  key: 0,
  class: "mt-5 text-gray-text text-sm"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-8" }
const _hoisted_7 = { class: "m-0 text-white font-bold truncate" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Choose Game ")
const _hoisted_9 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_10 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_11 = { class: "flex items-center justify-center min-h-full p-1 text-center sm:p-0" }
const _hoisted_12 = { class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-xl lg:max-w-3xl xl:max-w-4xl w-full m-2" }
const _hoisted_13 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_14 = { class: "modal-content bg-black-body text-white" }
const _hoisted_15 = { class: "modal-body p-5 md:p-10 text-justify z-50 relative" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-lg text-gray-300 mb-3" }, "Select Game", -1))
const _hoisted_17 = { class: "border-0 pb-1 md:grid sm:md:grid-cols-2 md:grid-cols-3 game-container" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "mr-3" }
const _hoisted_20 = {
  key: 0,
  class: "xr-icon-game text-gray-300 relative text-2xl inline-block w-8 h-8",
  style: {"top":"5px"}
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "text-md text-gray-300 truncate" }
const _hoisted_23 = { class: "p-2 flex justify-between border-0" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("  Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "Linked " + _toDisplayString($options.networkLabel) + " Games", 1),
    _hoisted_3,
    (_ctx.checkAttachedGames === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($options.networkLabel) + " token is not being used by any games yet.", 1))
      : _createCommentVNode("", true),
    (_ctx.checkAttachedGames === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachedGames, (attached) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex items-center py-4 px-5 rounded-md drop-shadow-md bg-black-header mr-2",
                key: attached.tokenId
              }, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(attached.gameTitle), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "btn bg-input-field text-white mt-5",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDisplayChooseGameModal = true))
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: "fa-solid fa-plus",
        class: "inline-block"
      }),
      _hoisted_8
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-30",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayChooseGameModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-30",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayChooseGameModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDisplayChooseGameModal = false))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "mb-3 mr-3",
                              key: game.gameId
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["flex items-center rounded-md drop-shadow-md bg-black-primary px-4 py-3 cursor-pointer", [game.name == this.selectedGame ? 'game-selected' : '']]),
                                onClick: ($event: any) => ($options.selectAttachedGameFunc(game.name))
                              }, [
                                _createElementVNode("div", _hoisted_19, [
                                  (game.logo === '' || game.logo == 'placeholder')
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                    : (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: $options.assetUrl + 'blob/games/' + game.gameId + '/' + game.logo,
                                        class: "w-8 h-8 rounded-full bg-black-ori"
                                      }, null, 8, _hoisted_21))
                                ]),
                                _createElementVNode("div", _hoisted_22, _toDisplayString(game.title), 1)
                              ], 10, _hoisted_18)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("button", {
                            class: "btn text-gray-text hover:text-gray-200 duration-200 transition-all mt-3",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDisplayChooseGameModal = false))
                          }, "Cancel"),
                          _createElementVNode("button", {
                            "data-bs-dismiss": "modal",
                            class: "btn btn-primary mt-3 float-end",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.saveAttachedGame && $options.saveAttachedGame(...args)))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "fa-solid fa-save",
                              class: "inline-block"
                            }),
                            _hoisted_24
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}